module.exports = __webpack_public_path__ + "images/icons/icon-board-1144836d074816486d76dff4570f0126.png";